// extracted by mini-css-extract-plugin
export default {"labelText":"labelText___CZln2","open":"open___R7kkX","root":"root___h0S8c","icon":"icon___Vkodt","label":"label___ygcOl","body":"body___sqL7L"};